export const tickerItems = [
  "新线索：某连锁品牌区域门店被指反复延后耗材更换周期",
  "编辑部完成对三家 MCN 合同附件的比对，相关稿件整理中",
  "读者来信：小区公共收益公示为何十年只见“合计”",
  "更正说明：7 月 30 日稿件中一处金额区间表述已修订",
  "匿名投递量本周环比上升，编辑部延长了初筛时段",
  "专题更新：隐形条款档案馆新增一篇职场内幕",
];

export const stats = [
  { label: "累计公开爆料", value: "1,286", unit: "篇" },
  { label: "经核实线索", value: "417", unit: "条" },
  { label: "被指涉方回应", value: "89", unit: "次" },
  { label: "更正与澄清", value: "36", unit: "条" },
];

export const principles = [
  {
    icon: "ri-shield-user-line",
    title: "信源优先保护",
    desc: "不记录、不留存可识别身份的信息。线人代号在内部随机生成，任何环节都不与真实身份关联，投稿内容默认加密处理。",
  },
  {
    icon: "ri-quill-pen-line",
    title: "先核实再发布",
    desc: "单一口述不足以成稿。我们尽可能用材料、公开信息与多方交叉印证，无法核实之处会明确标注为“待核实”。",
  },
  {
    icon: "ri-chat-check-line",
    title: "为回应留位置",
    desc: "发布前向被指涉方发出问询，稿件保留回应区块。即使回应与线人陈述冲突，也如实呈现，让读者自行判断。",
  },
  {
    icon: "ri-arrow-go-back-line",
    title: "错了就改",
    desc: "设更正机制，对每一次修订标注时间与原因，不做无声替换。可信度来自长期的一致，而不是某一篇的爆点。",
  },
];

export const testimonials = [
  {
    name: "读者 · 老陈",
    role: "连续跟踪三年",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20minimal%20portrait%20silhouette%20avatar%20in%20warm%20sepia%20tone%20on%20paper%20texture%20background%2C%20muted%20brick%20red%20and%20amber%20palette%2C%20abstract%20graphic%20style%2C%20no%20text%2C%20simple%20and%20clean&width=200&height=200&seq=heian-reader-01-avatar-2026&orientation=squarish",
    text: "这里的东西不急着下结论，把线索留给你自己判断。看完一篇，我会去查一遍相关的公开信息，这种被尊重的感觉很少见。",
  },
  {
    name: "线人 · 匿名",
    role: "曾投递两条行业线索",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20minimal%20portrait%20silhouette%20avatar%20in%20charcoal%20and%20amber%20tone%20on%20aged%20paper%20background%2C%20abstract%20graphic%20style%2C%20no%20text%2C%20simple%20and%20clean&width=200&height=200&seq=heian-reader-02-avatar-2026&orientation=squarish",
    text: "投出去的时候很怕，结果编辑先回了我一份脱敏建议。他们比我还谨慎，这一点让我愿意把知道的说完整。",
  },
  {
    name: "从业者 · 阿哲",
    role: "供应链相关岗位",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20minimal%20portrait%20silhouette%20avatar%20in%20muted%20green%20and%20sepia%20tone%20on%20textured%20paper%20background%2C%20abstract%20graphic%20style%2C%20no%20text%2C%20simple%20and%20clean&width=200&height=200&seq=heian-reader-03-avatar-2026&orientation=squarish",
    text: "同行都在私下聊的事，终于有人愿意写成能被查证的样子。不做标题党，反而更狠。",
  },
];

export const editorialTeam = [
  {
    name: "暗线编辑部",
    role: "线索核查与稿件整理",
    desc: "由调查报道与事实核查背景的编辑组成，负责把零散口述整理成有层级、可追溯的稿件。",
  },
  {
    name: "信源联络组",
    role: "匿名渠道维护",
    desc: "维护投稿入口与安全联络方式，负责与线人的持续沟通、脱敏建议与发布前告知。",
  },
  {
    name: "更正小组",
    role: "回应与修订",
    desc: "接收被指涉方与读者的更正请求，核对依据后安排修订，并公开标注修订时间与原因。",
  },
];

export const navLinks = [
  { name: "首页", href: "/" },
  { name: "爆料库", href: "/stories" },
  { name: "专题", href: "/topics" },
  { name: "常见问题", href: "/faq" },
  { name: "关于我们", href: "/about" },
];

export const contactInfo = {
  email: "tips@heianbaoliao.example.com",
  replyTime: "通常 3–7 个工作日内初筛",
  channel: "仅通过匿名投稿入口与公开邮箱联络",
};